module.exports = __webpack_public_path__ + "img/set-meeting.2dae35f7.svg";